/* eslint-disable react/no-unused-prop-types */
import { shape, string } from 'prop-types';
import { t } from '@lingui/macro';
import { defaultsDeep, identity } from 'lodash';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import EntityListFilter, { useEntity, useEntityName } from '../entity-list-filter/EntityListFilter';
import getEntityListFilterStateServiceFactory from '../entity-list-filter/EntityListFilterStateService';
import { ENTITY_TYPES } from '../../../services/EntityService';

export const filterId = 'Interface';
export const filterTitle = t`Interface`;
export const entityType = ENTITY_TYPES.INTERFACE;

export function useInterface() {
    return useEntity(filterId);
}

export function useInterfaceName() {
    return useEntityName(filterId);
}

const columns = [
    {
        title: 'Name',
        mapping: 'name',
        flex: 1,
        minWidth: 250,
        sortable: true,
        resizable: false,
    },
    {
        title: 'Device',
        width: 200,
        sortable: true,
        mapping: 'deviceName',
        resizable: false,
    },
    {
        title: 'Device IP',
        width: 200,
        sortable: true,
        mapping: 'deviceIpAddress',
    },
];

const dataSourceParams = {
    entityFields: ['name', 'deviceName', 'deviceIpAddress'],
};

function InterfaceFilter(props) {
    const { state, filterActions } = props;
    const options = { entityType, columns, dataSourceParams, showHeaders: true };
    return <EntityListFilter options={options} state={state} filterActions={filterActions} />;
}

InterfaceFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: shape({
        uuid: string.isRequired,
        name: string.isRequired,
    }),
};

InterfaceFilter.defaultProps = defaultsDeep(
    {
        options: {
            link: {
                target: '/interface-detail',
                mappedFilterParams: {
                    [filterId]: identity,
                },
            },
        },
        id: filterId,
        title: filterTitle,
        state: undefined,
        maxWidth: 'md',
        fullWidth: true,
    },
    EntityListFilter.defaultProps
);

export default Filter({
    filterId,
    filterStateServiceFactory: getEntityListFilterStateServiceFactory(filterTitle, entityType),
})(InterfaceFilter);
